import { render, staticRenderFns } from "./videoiframe.vue?vue&type=template&id=066e7cfd&"
import script from "./videoiframe.vue?vue&type=script&lang=js&"
export * from "./videoiframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('066e7cfd')) {
      api.createRecord('066e7cfd', component.options)
    } else {
      api.reload('066e7cfd', component.options)
    }
    module.hot.accept("./videoiframe.vue?vue&type=template&id=066e7cfd&", function () {
      api.rerender('066e7cfd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2GX7t4fEGPVG4/JS/videoiframe.vue"
export default component.exports